import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MusicToggle from "@/components/MusicToggle";
import FloatingHearts from "@/components/FloatingHearts";
import LoveNotes from "@/components/LoveNotes";
import MemoryPopup from "@/components/MemoryPopup";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="relative min-h-screen flex flex-col" data-testid="layout-root">
      <FloatingHearts />
      <LoveNotes />
      <MemoryPopup />
      <Navbar />
      <main className="relative z-10 flex-1">
        <Outlet />
      </main>
      <Footer />
      <MusicToggle />
    </div>
  );
}
